import React, { useState, useEffect } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { setBrandType, setBrandParams } from '../../../slices/brand/brandSlice'

import { Display } from '../../Display/Display'
import { Notice } from '../../Notice/Notice'
import { CustomRadioBtn } from '../../UI/CustomRadioBtn/CustomRadioBtn'

import { polystyreneFoam } from '../../../data/polystyrene-foam-data'

import './Brand.css'

const concatValue = (field) => {
  if (field) {
    return `${field.prefix} ${field.value}`
  }
}

export const Brand = () => {
  const dispatch = useDispatch();

  const brandType = useSelector(state => state.brand.brandType);
  const brandParams = useSelector(state => state.brand.brandParams);
  // const [brandParams, setBrandParams] = useState({});

  const clickHandler = (brandTitle) => {
    dispatch(setBrandType(brandTitle))
  }

  // console.log('brandType', brandType);

  useEffect(()=> {
    const curBrand = polystyreneFoam.find(polystyrene => polystyrene.title === brandType)

    if(curBrand) {
      dispatch(setBrandParams(curBrand));
    }
  }, [brandType])


  // добавить Название к калькулятору на сайте
  // Добавить ссылки на источнике на сайте 

  return (
    <div className='brand'>
      <div className="brand__group">
        <h3 className="brand__group-title">Выберите марку фасадного пенополистирола</h3>
        <div className="brand__group-wrapper">
          {
            polystyreneFoam.map(brand => {
              return <div className="brand__radio-wrapper" key={brand.title}>
                <CustomRadioBtn 
                  isSelected = {brandType === brand.title} 
                  onClick={clickHandler} 
                  selectId={brand.title}
                  className={'brand__radio'}
                >
                  {
                    brand.title
                  }
                </CustomRadioBtn>
              </div>
            })
          }
        </div>
      </div>

      <div className="brand__group">

        <div className="">
          <Display 
            className={'brand__display'} 
            text={'Прочность на сжатие, кПА'}
            displayParam={<span className='brand__display-value'> {concatValue(brandParams.compressive) ?? '—'} </span> }
            isCustomMobile={true}
          >
            <Notice>
              <div className="brand__notice-wrapper">
                Прочность на сжатие — показатель давления, которое способен выдержать материал. Чем выше показатель, тем более прочен материал. 
              </div>
            </Notice>
          </Display>
        </div>

        <div className="">
          <Display 
            className={'brand__display'} 
            text={'Предел прочности при изгибе, кПа, Вт/(м·К)'}
            displayParam={<span className='brand__display-value'> {concatValue(brandParams.flexural) ?? '—'}</span>}
            isCustomMobile={true}
          >
            <Notice>
              <div className="brand__notice-wrapper">
                Предел прочности при изгибе — максимальное напряжение, которое может выдержать материал при изгибе до разрушения. Высокий показатель говорит о прочности материала. Низкий — о хрупкости.
              </div>
            </Notice>
          </Display>
        </div>

        <div className="">
          <Display 
            className={'brand__display'} 
            text={'Теплопроводность при 10±1°С'}
            displayParam={<span className='brand__display-value'> { concatValue(brandParams.thermalConductivity10) ?? '—'} </span>}
            isCustomMobile={true}
          >
            <Notice>
              <div className="brand__notice-wrapper">
                Теплопроводность — способность более нагретого материала передавать тепло менее нагретому. Чем выше этот показатель, тем больше тепловой энергии способен передать или отдать материал в единицу времени.
              </div>
            </Notice>
          </Display>
        </div>

        <div className="">
          <Display 
            className={'brand__display'} 
            text={'Теплопроводность при 25±5°С, Вт/(м·К)'}
            displayParam={<span className='brand__display-value'> { concatValue(brandParams.thermalConductivity25) ?? '—'} </span>}
            isCustomMobile={true}
          >
            <Notice>
              <div className="brand__notice-wrapper">
                Теплопроводность — способность более нагретого материала передавать тепло менее нагретому. Чем выше этот показатель, тем больше тепловой энергии способен передать или отдать материал в единицу времени.
              </div>
            </Notice>
          </Display>
        </div>

        <div className="">
          <Display 
            className={'brand__display'} 
            text={'Влажность, % по массе'}
            displayParam={<span className='brand__display-value'> { concatValue(brandParams.humidity) ?? '—'} </span> }
            isCustomMobile={true}
          >
            <Notice>
              <div className="brand__notice-wrapper">
                Влажность по массе — это соотношение массы влаги, которая находится в образце в естественно-воздушных условиях, к массе этого образца в сухом состоянии. Чем ниже показатель, тем «суше» материал.
              </div>
            </Notice>
          </Display>
        </div>


        <div className="">
          <Display 
            className={'brand__display'} 
            text={'Водопоглощение при длительном полном погружении, % по объему'}
            displayParam={<span className='brand__display-value'> { concatValue(brandParams.waterAbsorption) ?? '—'} </span> }
            isCustomMobile={true}
          >
            <Notice>
              <div className="brand__notice-wrapper">
                Водопоглощение — способность материала впитывать и удерживать воду. Высокая способность к водопоглощению может ухудшить теплоизоляционные свойства материала.
              </div>
            </Notice>
          </Display>
        </div>

      </div>
    </div>
  )
}
